"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
const domain_1 = require("../../../domain");
const sortZones = (zoneA, zoneB) => {
    if (zoneA.name < zoneB.name) {
        return -1;
    }
    if (zoneA.name > zoneB.name) {
        return 1;
    }
    return 0;
};
class BrandMapper {
    toDomain(result) {
        const id = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.id");
        const importationType = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.importationType");
        const brand = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.brand");
        const externalServices = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.externalServices");
        const enabledPreferredZones = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.enabledPreferredZones", false);
        const maximumPreferredZones = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.maximumPreferredZones", 0);
        let zones = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.zones") || [];
        zones = [...zones].sort(sortZones);
        let visibleZones = [];
        let visibleAndOpenZones = [];
        zones.forEach((eachZone) => {
            const { pointOfSales } = eachZone, rest = __rest(eachZone, ["pointOfSales"]);
            const openPos = (pointOfSales === null || pointOfSales === void 0 ? void 0 : pointOfSales.filter(({ open }) => open)) || [];
            const isZoneVisible = eachZone.status === domain_1.ZoneStatus.VISIBLE;
            if (openPos.length > 0 && isZoneVisible) {
                // in the filters we show the visible zones that have open pos
                visibleAndOpenZones.push(rest);
                visibleZones.push(rest);
            }
            else if (isZoneVisible) {
                // in the forced modal we show the visible zones even if they dont have any pos open
                visibleZones.push(rest);
            }
        });
        let preferredZones = lodash_1.default.get(result, "data.getUser.currentHoldingView.preferredZones") || [];
        preferredZones = preferredZones.map((eachPreferredZone) => ({ name: eachPreferredZone.name })).sort(sortZones);
        const visibleAndOpenPreferredZones = [];
        const visiblePreferredZones = [];
        preferredZones.forEach((eachPreferredZone) => {
            const isZoneVisibleAndOpen = visibleAndOpenZones.some((eachZone) => eachZone.name === eachPreferredZone.name);
            if (isZoneVisibleAndOpen) {
                // in the filters we only show the preferred zones that the zone is visible with open pos
                visibleAndOpenPreferredZones.push(eachPreferredZone);
                // in the force modal we show the visible zones even if they don't have any pos open
                visiblePreferredZones.push(eachPreferredZone);
            }
            else {
                const isZoneVisible = visibleZones.some((eachZone) => eachZone.name === eachPreferredZone.name);
                if (isZoneVisible) {
                    visiblePreferredZones.push(eachPreferredZone);
                }
            }
        });
        return {
            id,
            brand,
            externalServices,
            importationType,
            enabledPreferredZones,
            maximumPreferredZones,
            preferredZones: visibleAndOpenPreferredZones,
            zones: visibleAndOpenZones,
            visibleZones,
            // we use the unfiltered preferred zones values from the DB to check if we should show the modal to
            // force the preferred zones selection or not
            savedPreferredZones: visiblePreferredZones
        };
    }
}
exports.BrandMapper = BrandMapper;
